module.exports = __webpack_public_path__ + "img/balcon-2.324cc35c.jpg";